import { Badge } from "@/components/ui/badge"
import { gmTone, pct } from "@/lib/money"

/** A GM% pill toned against its target: healthy = accent, under = signal,
 *  uncomputable = muted em dash. Comparison only — never arithmetic. */
export function GmChip({
  actual,
  target,
  testid,
}: {
  actual: string | null
  target: string | null
  testid?: string
}) {
  if (actual == null) {
    return (
      <Badge tone="muted" data-testid={testid}>
        —
      </Badge>
    )
  }
  return (
    <Badge tone={gmTone(actual, target)} data-testid={testid}>
      {pct(actual)}
    </Badge>
  )
}
